<script lang="ts">
    import {dyData, modal} from 'general/store';
    import {BACKGROUND_COLOR, TEMPLATE} from 'general/constants';

    import Description from 'general/components/description/Description.svelte';
    import ActionButton from 'general/components/actionButton/ActionButton.svelte';
    import OpacityItem from 'general/components/flip/opacityItem/OpacityItem.svelte';
    import DyButton from 'general/components/dyButton/DyButton.svelte';

    import s from './style.module.css';

    const isLight = $dyData.side.typ?.backgroundColor === BACKGROUND_COLOR.LIGHT;
</script>

<OpacityItem delayIn={0}>
    <div
        class={s.main}
        class:s.light={isLight}
        class:s.colored={!isLight}
        style="margin-top: {$dyData.side.typ?.marginTop || 0}"
    >
        <Description template={TEMPLATE.SQUARE_EXIT} value={$dyData.description?.typ} />
        <div class="buttonContainer">
            <DyButton
                type="quiz"
                href="/pairfect_match"
                children="Take The Quiz"
                onClick={modal.close}
                size="large"
                color="mine-shaft"
                {...$dyData.mainButton?.typ || {}}
            />
        </div>
        <ActionButton
            color="gray"
            marginTop="28px"
            children="Continue shopping"
            fontSize="18px"
            handleClick={modal.close}
            template={TEMPLATE.SQUARE_EXIT}
        />
    </div>
</OpacityItem>
